import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { getLabel, getSortedVenueCategoryLabels, initialVenueCategoryFilter } from "./FilterTypes/VenueCategoryFilterType";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";

const venueCategories = serverReference.venueCategories.filter(vc => vc.value !== "unknown");
const unknownVenueCategory = serverReference.venueCategories.find(vc => vc.value === "unknown");

const VenueCategoryFilter = () => {
  const title = RESX.Venue.Category;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("venueCategory", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedVenueCategoryLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedVenueCategories.length > 0,
    reset: () => ({
      selectedVenueCategories: []
    }),
    areEqual: (a, b) => {
      return areArrayValuesEqual(a.selectedVenueCategories, b.selectedVenueCategories);
    }
  });
  useEffect(() => {
    setInitialValue("venueCategory", initialVenueCategoryFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedVenueCategories, setSelectedVenueCategories] = React.useState(initialVenueCategoryFilter.selectedVenueCategories);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedVenueCategories(getValue("venueCategory").selectedVenueCategories);
    setPopupOpen(true);
  };

  const onVenueCategoryToggle = (venueCategory: server.dto.VenueCategories) => {
    const isSelected = selectedVenueCategories.some(v => v === venueCategory);
    const newSelection = isSelected
      ? selectedVenueCategories.filter(v => v !== venueCategory)
      : [...selectedVenueCategories, venueCategory];
    setSelectedVenueCategories(newSelection);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("venueCategory", {
      selectedVenueCategories
    });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={[unknownVenueCategory].map(vc => vc.value)}
            selectedItems={selectedVenueCategories}
            onItemToggled={onVenueCategoryToggle}
            getId={opt => opt}
            getName={opt => getLabel(opt)}
          />
        </div>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={venueCategories.map(vc => vc.value)}
            selectedItems={selectedVenueCategories}
            onItemToggled={onVenueCategoryToggle}
            getId={opt => opt}
            getName={opt => getLabel(opt)}
          />
        </div>

        <Button fluid type="submit" primary>
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default VenueCategoryFilter;